import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface DeleteAgentDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  selectedAgentName: string;
  deleteConfirmText: string;
  onDeleteConfirmChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isDeleteButtonDisabled: boolean;
  isDeleting: boolean;
}

export const DeleteAgentDialog: React.FC<DeleteAgentDialogProps> = ({
  isOpen,
  onClose,
  onDelete,
  selectedAgentName,
  deleteConfirmText,
  onDeleteConfirmChange,
  isDeleteButtonDisabled,
  isDeleting,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Agent</DialogTitle>
          <DialogDescription>
            This action cannot be undone. This will permanently delete the agent
            "{selectedAgentName}" and all its conversations.
            <br />
            <br />
            Please type <strong>delete</strong> to confirm.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <Label htmlFor="deleteConfirm" className="text-sm font-medium">
            Type "delete" to confirm:
          </Label>
          <Input
            id="deleteConfirm"
            value={deleteConfirmText}
            onChange={onDeleteConfirmChange}
            placeholder="delete"
            className="mt-2"
            disabled={isDeleting}
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onDelete}
            disabled={isDeleteButtonDisabled || isDeleting}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {isDeleting ? (
              <>
                <div className="h-4 w-4 mr-2 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                Deleting...
              </>
            ) : (
              "Delete Agent"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
